"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataRequestStatus = exports.all = void 0;
// @HINT: Remember to update the validation schema when changing values here!
var DataRequestStatus;
(function (DataRequestStatus) {
    DataRequestStatus["WaitingForApproval"] = "Warten auf Verifizierung GA";
    DataRequestStatus["Approved"] = "GA verifiziert";
    DataRequestStatus["WaitingForDownload"] = "Warten auf Datenabruf";
    DataRequestStatus["Complete"] = "Abgeschlossen";
    DataRequestStatus["SuspectFraud"] = "Unter Betrugsverdacht";
    DataRequestStatus["Denied"] = "Abgelehnt";
})(DataRequestStatus || (DataRequestStatus = {}));
exports.DataRequestStatus = DataRequestStatus;
const all = 'Alle';
exports.all = all;
